import { NBA_CLICKSTREAM_EVENT_TYPE, NBA_CLICKSTREAM_SCHEMA_DATA } from './nbaClickstreamEventSchema';
export function formNBANewLaneEventPayload(eventType, newLaneEventData, reaction) {
  var _NBA_CLICKSTREAM_SCHE = NBA_CLICKSTREAM_SCHEMA_DATA(newLaneEventData.triggerLocation, newLaneEventData.triggerObject, newLaneEventData.triggerSource)[eventType],
      envelopeBlock = _NBA_CLICKSTREAM_SCHE.envelopeBlock,
      triggerBlock = _NBA_CLICKSTREAM_SCHE.triggerBlock,
      semanticBlock = _NBA_CLICKSTREAM_SCHE.semanticBlock,
      nbaBlock = _NBA_CLICKSTREAM_SCHE.nbaBlock;
  var nbaBlockRenderedProps = Object.assign({}, newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.nbaContext);

  if (eventType === NBA_CLICKSTREAM_EVENT_TYPE.IMPRESSION) {
    nbaBlockRenderedProps = Object.assign(Object.assign({}, nbaBlockRenderedProps), {}, {
      positions_seen: [newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.position]
    });
  } else if (eventType === NBA_CLICKSTREAM_EVENT_TYPE.INTERACTION && reaction) {
    var _position_interaction;

    nbaBlockRenderedProps = Object.assign(Object.assign({}, nbaBlockRenderedProps), {}, {
      position_interactions: (_position_interaction = {}, _position_interaction[newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.position] = reaction, _position_interaction)
    });
  }

  var properties = {
    envelope: Object.assign({
      event_client_start_dtm: new Date().toISOString()
    }, envelopeBlock),
    clickstream_trigger: Object.assign(Object.assign({}, triggerBlock), {}, {
      // TODO: MTT-2939 update input_selector as we start tracking emitter info
      // (like mouse, keyboard, touch)
      input_selector_nm: 'other'
    }),
    semantic: Object.assign({}, semanticBlock),
    nba_content_selection: Object.assign(Object.assign({
      semantic_version_id: 1
    }, nbaBlock), nbaBlockRenderedProps)
  };
  return properties;
}